module.exports = __webpack_public_path__ + "static/media/expiredplan.4125a58c.svg";